import { useLanguage } from '../lib/i18n/LanguageContext';

/**
 * Shown wherever an org-scoped route reports that this account has no
 * organization — `hasOrg === false` from SessionContext, or a live 403 with
 * the same meaning. This is the expected shape of a brand-new account
 * mid-onboarding, not a failure, so it renders as an empty state rather than
 * an error screen: no red, no "something went wrong" iconography.
 */
export function OnboardingNotice({ area }: { area: string }) {
  const { dict } = useLanguage();
  return (
    <div className="empty-panel">
      <h2>{dict.onboarding.title(area)}</h2>
      <p>{dict.onboarding.body}</p>
      <p className="note">{dict.onboarding.note}</p>
    </div>
  );
}
